export default "__VITE_ASSET__CMYwYU4R__"